import { useState, useCallback } from 'react';
import axios from 'axios';
import { JournalEntry, Pagination } from '../types';
import { API_BASE, DEFAULT_PAGE_LIMIT } from '../constants';
import { SortField, Order } from '../types';

export interface JournalEntriesState {
  entries: JournalEntry[];
  tableLoading: boolean;
  pagination: Pagination | null;
  fetchEntries: (page: number) => Promise<void>;
}

/**
 * Загружает страницу записей журнала с сервера.
 * Поддерживает пагинацию, сортировку и произвольные фильтры.
 */
export function useJournalEntries(
  filterParams: Record<string, string>,
  orderBy: SortField,
  order: Order,
): JournalEntriesState {
  const [entries, setEntries] = useState<JournalEntry[]>([]);
  const [tableLoading, setTableLoading] = useState(true);
  const [pagination, setPagination] = useState<Pagination | null>(null);

  const fetchEntries = useCallback(async (currentPage: number) => {
    setTableLoading(true);
    try {
      const resp = await axios.get(`${API_BASE}/journal`, {
        params: {
          ...filterParams,
          orderBy,
          order,
          page: currentPage,
          limit: DEFAULT_PAGE_LIMIT,
        },
      });
      if (resp.data?.success) {
        setEntries(resp.data.data || []);
        setPagination(resp.data.pagination || null);
      }
    } catch (e) {
      console.error('Journal fetch error:', e);
    } finally {
      setTableLoading(false);
    }
  }, [filterParams, orderBy, order]);

  return { entries, tableLoading, pagination, fetchEntries };
}
